module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.forum) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.forum) ? _c('section', {
    staticClass: "threads"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.root)
    }
  }, [_vm._v(_vm._s(_vm.category.title))]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.forum.title) + "\n        ")], 1), _vm._v(" "), _c('section', {
    staticClass: "pagination"
  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "max-page": _vm.totalPages,
      "current-page": _vm.currentPage,
      "spread": 5
    },
    on: {
      "switchToPage": _vm.switchToResultsPage
    }
  })], 1), _vm._v(" "), (_vm.canPost && !_vm.addThreadMode) ? _c('section', {
    staticClass: "controls"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.addThreadMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" Create a new Thread")])]) : _vm._e(), _vm._v(" "), (_vm.addThreadMode) ? _c('section', {
    staticClass: "add-thread-form"
  }, [(_vm.newThreadSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.newThreadSaving) ? [_c('h3', [_vm._v("Create a Thread")]), _vm._v(" "), (_vm.newThreadErrorMessage) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.newThreadErrorMessage))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newThreadTitle),
      expression: "newThreadTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Thread Subject"
    },
    domProps: {
      "value": (_vm.newThreadTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newThreadTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content"
    },
    model: {
      value: (_vm.newThreadContent),
      callback: function($$v) {
        _vm.newThreadContent = $$v
      },
      expression: "newThreadContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.addThreadMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.saveNewThread
    }
  }, [_vm._v("Save")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "thread-list"
  }, [_vm._m(0), _vm._v(" "), (_vm.forum.fetchingStatus !== 'fetched') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.forum.fetchingStatus === 'fetched' && _vm.threads.length === 0) ? _c('div', {
    staticClass: "no-threads"
  }, [_vm._v("No one has posted a thread in this forum yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.threads), function(thread) {
    return (_vm.forum.fetchingStatus === 'fetched') ? _c('router-link', {
      staticClass: "thread",
      attrs: {
        "to": ("/" + _vm.root + "/" + (_vm.$route.params.category) + "/" + (_vm.$route.params.forum) + "/" + (thread.stringUrl))
      }
    }, [_c('div', {
      staticClass: "title"
    }, [(thread.locked) ? _c('i', {
      staticClass: "fas fa-lock"
    }) : _vm._e(), (thread.pinned) ? _c('i', {
      staticClass: "fas fa-thumbtack"
    }) : _vm._e(), _vm._v(_vm._s(thread.title))]), _vm._v(" "), _c('div', {
      staticClass: "last-reply"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(thread.lastPostTime)))]), _vm._v(" "), _c('div', {
      staticClass: "stats"
    }, [_c('span', [_vm._v(_vm._s(thread.totalPosts) + " posts")]), _c('span', [_vm._v(_vm._s(thread.views) + " views")])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "pagination"
  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "max-page": _vm.totalPages,
      "current-page": _vm.currentPage,
      "spread": 5
    },
    on: {
      "switchToPage": _vm.switchToResultsPage
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "thread-list-header"
  }, [_c('div', [_vm._v("Subject")]), _vm._v(" "), _c('div', [_vm._v("Last Reply")]), _vm._v(" "), _c('div', [_vm._v("Stats")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53bc73fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsThreadList.vue
// module id = 871
// module chunks = 2